import axios from "axios";
import React from "react";

const baseURL = "https://standalone-express.vercel.app/api/handler";
export default function Precos() {
  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.get(baseURL).then((response) => {
      setPost(response.data);
      
    });
  }, []);

  if (!post) return null;

  return (
    <div>
      <h1>{post.descricao}</h1>
      <p>{post.preco}</p>
    </div>
  );
}
